<template>
  <div class="audio-dialog" v-if="page.dialogVisible">
    <div class="close" @click="close">
      <el-icon :size="30"><CloseBold /></el-icon>
    </div>
    <video ref="videoPlayer" style="width: 100%;height: 100%;" :src="path" controls autoplay class="video" />
  </div>
</template>
<script setup>
import { reactive, defineProps, defineExpose, ref } from 'vue'

const videoPlayer = ref()
const page = reactive({
  dialogVisible: false,
})

const close = () => {
  page.dialogVisible = false
  videoPlayer.value.pause() // 停止播放
  videoPlayer.value.currentTime = 0
}

const path = ref()
const open = (url) => { 
  path.value = url
  page.dialogVisible = true
  if (videoPlayer.value) {
    videoPlayer.value.currentTime = 0 // 重头开始播放
    videoPlayer.value.play()
  }
}



defineExpose({
  open
})
</script>

<style lang="less" scoped>
.audio-dialog {
  position: fixed;
  inset: 0;
  background: #000;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  .close{
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
  }
  .video{
    width: 100% !important;
    height: 80% !important;
  }
}

</style>
